// extracted by mini-css-extract-plugin
module.exports = {"container":"Affiliates_container__3PpuG","title":"Affiliates_title__1hrVn"};